<template>
  <div class="app-wrapper">
    <!-- 导航栏 -->
    <Header v-if="!hideHeader"></Header>
    <!-- 内容区域 -->
    <div v-bind:class="{ main: true, hideHeader: hideHeader }">
      <Sidebar></Sidebar>
      <div class="content">
        <router-view class="content-wrapper" />
      </div>
    </div>
    <!-- 底部栏 -->
    <Footer></Footer>
    <!-- 开发者公众号侧边推广弹窗 -->
    <!-- <DeveloperWechatPopup /> -->
  </div>
</template>

<script>
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import qs from 'qs';
// import { DeveloperWechatPopup } from '@mini1/vue2-components';

export default {
  components: {
    Header,
    Sidebar,
    Footer,
    // DeveloperWechatPopup
  },
  data() {
    return {
      hideHeader: false,
    };
  },
  created() {
    const search = window.location.href.split('?').pop();
    let { iframe } = qs.parse(search);
    this.hideHeader = iframe === 'dev-wiki';
  },
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  justify-content: space-between;

  width: 1280px;
  min-height: calc(100vh - 260px);
  margin: 80px auto 30px;
  &.hideHeader {
    margin-top: 0;
  }
}

.content {
  width: 1056px;
}
</style>
